<template>
  <div class="dropshipping-wrapper">
    <div class="wholesale">
      Wholesale
    </div>
    <div class="dropshipping">
      <Button
        class="dropshipping__button"
        @click="onClick"
        :class="{ 'dropshipping__button--bounded': hasBoundStore }"
        :loading="loading"
        :block="false"
      >
        <div
          v-if="hasBoundStore"
          class="dropshipping__bounded"
        >
          <Icon name="shop" />
          <Icon
            class="dropshipping__bounded--right"
            name="right-l"
          />
        </div>
        <Icon
          v-else
          name="shop"
          class="dropshipping__unbound"
        />
        {{ hasBoundStore ? 'Go Dropshipping' : 'Start Dropshipping' }}
        <img
          v-if="hasBoundStore"
          class="dropshipping__badge"
          src="@/assets/offer/free-sample.png"
          alt="free sample"
        >
      </Button>
    </div>
  </div>
</template>

<script setup>
import { useDropshipping } from '@/components/Dropshipping'
import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'

defineProps({
  moq: Number
})

const { loading, hasBoundStore } = useDropshipping()
const onClick = () => {
  window.location.href = import.meta.env.VITE_QUOTE_URL
}
</script>

<style lang="less" scoped>
.dropshipping-wrapper {
  padding-top: 24px;
  display: flex;
  width: 100%;
  height: 48px;
  box-sizing: content-box;
  overflow: hidden;

  .wholesale {
    position: relative;
    flex: 1;
    max-width: 286px;
    border-radius: 8px 8px 0 0;
    border: 1px solid #EBF1F5;
    border-bottom: none;
    color: #232323;
    font-size: 14px;
    font-family: mon-600;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 4px 0px 6px 0px #1414141A;
  }
  .dropshipping {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #EBF1F5;

    &__button {
      position: relative;
      gap: 4px;
      padding: 5px 12px 5px 8px;
      height: auto;
      font-size: 12px;
      color: #232323;
      background-color: #F8F8F8;
      border: 1px solid #DFDFDF;

      &--bounded {
        background-color: white;
        border-color: currentColor;
      }
    }

    &__unbound {
      box-sizing: content-box;
      font-size: 16px;
      padding: 2px;
      border-radius: 100%;
      color: white;
      background-color: #1B3E9C;
    }

    &__bounded {
      position: relative;
      font-size: 20px;

      > svg {
        display: block;
      }

      &--right {
        position: absolute;
        right: -2px;
        bottom: 0;
        font-size: 6px;
        padding: 1px;
        box-sizing: content-box;
        background-color: #1B3E9C;
        border: 1.5px solid #FFFFFF;
        border-radius: 100%;
        color: white;
      }
    }

    &__badge {
      position: absolute;
      left: 50%;
      top: -15px;
      transform: translate(-50%, 0);
      height: 19px;
    }
  }
}
</style>
